import {useTranslation} from '@aboutyou/i18n';
import {
  Button,
  EmptyState,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  tabletAndUp,
  Text,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc, {css} from 'styled-components';

export const ProductStreamEmpty = ({
  onFilterClear,
}: {
  onFilterClear: VoidFunction;
}) => {
  const {t} = useTranslation();

  return (
    <EmptyState
      data-testid="ProductStreamEmpty"
      asset={<IconWrapper asset={GenericIconName.EmptySearch} />}
      title={
        <StyledHeading as="h1">
          {t('We are sorry... Nothing was found')}
        </StyledHeading>
      }
      subtitle={t(
        'Modify your filters to obtain the appropriate search results.',
      )}
      cta={
        <StyledButton variant="secondary" onClick={onFilterClear}>
          {t('Clear all filters')}
        </StyledButton>
      }
    />
  );
};

export const StyledButton = sc(Button)``;

export const IconWrapper = linariaStyled(Icon)`
  width: 110px;
  height: 160px;
  flex-basis: 85px;
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.04), 0 -2px 4px 0 rgba(0, 0, 0, 0.02);
`;

export const StyledHeading = sc(Text)`
  font-weight: ${FONT_WEIGHTS.bold};
  font-size: ${FONT_SIZES.px20};

  ${tabletAndUp(css`
    font-size: ${FONT_SIZES.px24};
  `)}
`;
